module.exports = __webpack_public_path__ + "img/icon_map_2_off_100.1adf2058.png";